module.exports = function() {
  return new Worker(__webpack_public_path__ + "bf1ab0b09c8e36c6e9d7.worker.js");
};